import { Check, CloudUpload } from 'lucide-react';

export type SaveStatus = 'saving' | 'saved' | 'idle';

export const SaveStatusIcon = ({ status }: { status: SaveStatus }) => {
  switch (status) {
    case 'saving':
      return (
        <div className="ms-2">
          <CloudUpload className="h-4 w-4 text-blue-500" />
        </div>
      );
    case 'saved':
      return (
        <div className="ms-2">
          <Check className="h-4 w-4 text-green-500" />
        </div>
      );
    default:
      return null;
  }
};
